"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GaClientIdManager = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _constants = require("../constants/constants");
var GaClientIdManager = exports.GaClientIdManager = /*#__PURE__*/function () {
  function GaClientIdManager() {
    (0, _classCallCheck2["default"])(this, GaClientIdManager);
  }
  return (0, _createClass2["default"])(GaClientIdManager, null, [{
    key: "getGaClientId",
    value: function getGaClientId() {
      return sessionStorage.getItem(_constants.SESSION_STORAGE_KEYS.BWA_GA_CLIENT_ID_KEY);
    }
  }, {
    key: "setGaClientId",
    value: function setGaClientId(clientId) {
      if (clientId) {
        sessionStorage.setItem(_constants.SESSION_STORAGE_KEYS.BWA_GA_CLIENT_ID_KEY, clientId);
      }
    }
  }, {
    key: "getGaClientIdFromCookie",
    value: function getGaClientIdFromCookie() {
      var gaCookie = document.cookie.split('; ').find(function (row) {
        return row.startsWith('_ga=');
      });
      if (gaCookie) {
        return gaCookie.split('=')[1].split('.').slice(-2).join('.');
      }
    }
  }, {
    key: "initializeGaClientId",
    value: function initializeGaClientId() {
      var clientId = this.getGaClientIdFromCookie();
      if (clientId) {
        this.setGaClientId(clientId);
      }
    }
  }]);
}(); // Initialize on load
if (typeof window !== 'undefined') {
  window.addEventListener('load', function () {
    GaClientIdManager.initializeGaClientId();
  });
}
//# sourceMappingURL=ga-client-id-manager.js.map
